var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M23.45 1.82549C22.4923 2.50096 21.4321 3.01759 20.31 3.35549C19.7077 2.663 18.9073 2.17218 18.017 1.94941C17.1267 1.72665 16.1894 1.78268 15.332 2.10994C14.4746 2.4372 13.7384 3.01989 13.2229 3.7792C12.7075 4.53852 12.4376 5.43782 12.45 6.35549V7.35548C10.6926 7.40105 8.95123 7.0113 7.38096 6.22093C5.81069 5.43056 4.46027 4.26412 3.44995 2.82549C3.44995 2.82549 -0.550049 11.8255 8.44995 15.8255C6.39048 17.2235 3.93711 17.9244 1.44995 17.8255C10.45 22.8255 21.45 17.8255 21.45 6.32549C21.449 6.04694 21.4222 5.76908 21.37 5.49549C22.3906 4.48898 23.1108 3.2182 23.45 1.82549Z","stroke":"#F4F4F4","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Twitter.defaultProps = {"width":"25","height":"21","viewBox":"0 0 25 21","fill":"none"};

module.exports = Twitter;

Twitter.default = Twitter;
